<div class="row align-items-center">
  <div class="col-sm-12 col-lg-5 col-md-5 col-xl-6">
    <div class="d-flex align-items-center">
      <!--<div>
        <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
          <i-tabler name="scale" class="icon-28" style="line-height: 30px !important"></i-tabler>
        </button>
      </div>-->
      <!--<div class="m-l-10">-->
      <div class="">
        <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
          Reports
        </h4>
      </div>
    </div>
  </div>
</div>
<mat-card class="m-t-20" style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
  <mat-card-content class="p-16">

    <h4 class="headingmain f-s-16 f-w-800 m-t-0 m-r-10">
      Charity Report
    </h4>

    <div class="m-t-20">
      <mat-card>
        <mat-card-content class="p-16" style="border-radius: 14px;">
          <div class="row align-items-center">
            <div class="col-lg-9">
              <div class="">
                <mat-card-title class="mat-mdc-card-title ">
                  <h4 class="f-s-16 f-w-600">Charity List Report</h4>
                </mat-card-title>
                <h4 class="f-s-14 f-w-400">
                  This report provides a list of all the imported charities in the software.
                </h4>
              </div>
            </div>
            <div class="col-lg-3 text-right">
              <button mat-flat-button color="primary" (click)="openCharityList()">
                <div class="d-flex align-items-center">
                  <i-tabler class="icon-16 m-r-10" name="eye"></i-tabler> View Report
                </div>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <!--<div class="m-t-20">
    <mat-card>
      <mat-card-content class="p-16" style="border-radius: 14px;">
        <div class="row align-items-center">
          <div class="col-lg-9">
            <div class="">
              <mat-card-title class="mat-mdc-card-title ">
                <h4 class="f-s-16 f-w-600">
                  Charity Details Report
                </h4>
              </mat-card-title>
              <h4 class="f-s-14 f-w-400">
                This report/view provides comprehensive information for a single selected charity. It compiles data from the "Basic Information" and "Professional Advisors" modules.
              </h4>
            </div>
          </div>
          <div class="col-lg-3 text-right">
            <button mat-flat-button color="primary">
              <div class="d-flex align-items-center">
                <i-tabler class="icon-16 m-r-10" name="eye"></i-tabler> View Report
              </div>
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>-->

    <h4 class="headingmain f-s-16 f-w-800 m-t-0 m-r-10">
      Trustee Report
    </h4>

    <div class="m-t-20">
      <mat-card>
        <mat-card-content class="p-16" style="border-radius: 14px;">
          <div class="row align-items-center">
            <div class="col-lg-9">
              <div class="">
                <mat-card-title class="mat-mdc-card-title ">
                  <h4 class="f-s-16 f-w-600">
                    Trustee List Report
                  </h4>
                </mat-card-title>
                <h4 class="f-s-14 f-w-400">
                  This report provides a list of all current and past trustees for a selected charity.
                </h4>
              </div>
            </div>
            <div class="col-lg-3 text-right">
              <button mat-flat-button color="primary" (click)="openTrusteeList()">
                <div class="d-flex align-items-center">
                  <i-tabler class="icon-16 m-r-10" name="eye"></i-tabler> View Report
                </div>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <!--<div class="m-t-20">
    <mat-card>
      <mat-card-content class="p-16" style="border-radius: 14px;">
        <div class="row align-items-center">
          <div class="col-lg-9">
            <div class="">
              <mat-card-title class="mat-mdc-card-title ">
                <h4 class="f-s-16 f-w-600">
                  Trustees' Annual Report (TAR)
                </h4>
              </mat-card-title>
              <h4 class="f-s-14 f-w-400">
                This structured document provides key information required by the Charity Commission and SORP for a selected charity.
              </h4>
            </div>
          </div>
          <div class="col-lg-3 text-right">
            <button mat-flat-button color="primary">
              <div class="d-flex align-items-center">
                <i-tabler class="icon-16 m-r-10" name="eye"></i-tabler> View Report
              </div>
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>-->

    <h4 class="headingmain f-s-16 f-w-800 m-t-0 m-r-10">
      Trial Balance Report
    </h4>

    <div class="m-t-20">
      <mat-card>
        <mat-card-content class="p-16" style="border-radius: 14px;">
          <div class="row align-items-center">
            <div class="col-lg-9">
              <div class="">
                <mat-card-title class="mat-mdc-card-title ">
                  <h4 class="f-s-16 f-w-600">
                    Trial Balance Report
                  </h4>
                </mat-card-title>
                <h4 class="f-s-14 f-w-400">
                  This report provide the details of Trial Balance for a selected Charity and Accounting Period.
                </h4>
              </div>
            </div>
            <div class="col-lg-3 text-right">
              <button mat-flat-button color="primary" (click)="openTrailBalance()">
                <div class="d-flex align-items-center">
                  <i-tabler class="icon-16 m-r-10" name="eye"></i-tabler> View Report
                </div>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <h4 class="headingmain f-s-16 f-w-800 m-t-0 m-r-10">
      Chart of Accounts Report
    </h4>

    <div class="m-t-20">
      <mat-card>
        <mat-card-content class="p-16" style="border-radius: 14px;">
          <div class="row align-items-center">
            <div class="col-lg-9">
              <div class="">
                <mat-card-title class="mat-mdc-card-title ">
                  <h4 class="f-s-16 f-w-600">
                    Chart of Accounts Report
                  </h4>
                </mat-card-title>
                <h4 class="f-s-14 f-w-400">
                  This report provide the details of Chart of Accounts.
                </h4>
              </div>
            </div>
            <div class="col-lg-3 text-right">
              <button mat-flat-button color="primary" (click)="openChartofAccountsReport()">
                <div class="d-flex align-items-center">
                  <i-tabler class="icon-16 m-r-10" name="eye"></i-tabler> View Report
                </div>
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>


  </mat-card-content>
</mat-card>
